"use client";
import * as React from "react";
const SvgCallOutlined = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M3.15 1.78q.07 1.19.4 2.3L2.48 5.15a13 13 0 0 1-.68-3.37zm8.76 10.68a11 11 0 0 0 2.31.4v1.33a14 14 0 0 1-3.38-.67zM4 0H.89A.9.9 0 0 0 0 .89 15.1 15.1 0 0 0 15.11 16a.9.9 0 0 0 .89-.89v-3.1a.9.9 0 0 0-.89-.89q-1.67-.01-3.17-.5a1 1 0 0 0-.28-.05 1 1 0 0 0-.63.26l-1.95 1.95a13.5 13.5 0 0 1-5.86-5.85l1.95-1.96a.9.9 0 0 0 .23-.9A10 10 0 0 1 4.89.88.9.9 0 0 0 4 0" }));
export {
  SvgCallOutlined as default
};
